var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "footer", style: _vm.cssVars }, [
    _c("div", { staticClass: "upper container" }, [
      _vm.window.width <= 1024
        ? _c("a", { staticClass: "brand_mob", attrs: { href: "/" } }, [
            _c("img", {
              attrs: {
                src: _vm.parsedGlobalSettings.footer.footer_logo
                  ? _vm.parsedGlobalSettings.footer.footer_logo.url
                  : this.logo,
                alt: "PIP",
                height: "50",
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "footer_col one" }, [
        _vm.window.width > 1024
          ? _c("a", { staticClass: "brand", attrs: { href: "/" } }, [
              _c("img", {
                attrs: {
                  src: _vm.parsedGlobalSettings.footer.footer_logo
                    ? _vm.parsedGlobalSettings.footer.footer_logo.url
                    : this.logo,
                  alt: "PIP",
                  height: "50",
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.parsedGlobalSettings.general.aoc
          ? _c("div", {
              staticClass: "aoc",
              domProps: {
                innerHTML: _vm._s(_vm.parsedGlobalSettings.general.aoc),
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.parsedGlobalSettings.footer.social_channels
          ? _c(
              "ul",
              { staticClass: "socials" },
              [
                _vm._l(
                  _vm.parsedGlobalSettings.footer.social_channels,
                  function (channel, index) {
                    return [
                      channel.url != false
                        ? _c("li", { key: index }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: channel.url.url,
                                  target: channel.url.target,
                                },
                              },
                              [
                                channel.icon != false
                                  ? _c("img", {
                                      attrs: {
                                        src: channel.icon.url,
                                        alt: index,
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  }
                ),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer_col two" }, [
        _vm.parsedGlobalSettings.footer.contact
          ? _c(
              "ul",
              { staticClass: "contact" },
              [
                _vm._l(
                  _vm.parsedGlobalSettings.footer.contact,
                  function (channel, index) {
                    return [
                      channel.url != false
                        ? _c("li", { key: index }, [
                            _c(
                              "a",
                              {
                                attrs: { href: channel.url, target: "_blank" },
                              },
                              [
                                channel.icon != false
                                  ? _c("img", {
                                      attrs: { src: channel.icon, alt: index },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(channel.label),
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _c("li", { key: index + "_no_link" }, [
                            _c("a", { staticClass: "no_link" }, [
                              channel.icon != false
                                ? _c("img", {
                                    attrs: { src: channel.icon, alt: index },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", {
                                domProps: { innerHTML: _vm._s(channel.label) },
                              }),
                            ]),
                          ]),
                    ]
                  }
                ),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.parsedFooterMenu
        ? _c("div", { staticClass: "footer_col three" }, [
            _c(
              "ul",
              _vm._l(_vm.parsedFooterMenu, function (footer_link, index) {
                return _c("menu-item", {
                  key: index,
                  attrs: {
                    menu_item: footer_link,
                    "has-children": footer_link.children ? true : false,
                    selected: footer_link.object_id == _vm.current_id,
                  },
                })
              }),
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.parsedFooterMenuTwo
        ? _c("div", { staticClass: "footer_col four" }, [
            _c(
              "ul",
              _vm._l(_vm.parsedFooterMenuTwo, function (footer_link, index) {
                return _c("menu-item", {
                  key: index,
                  attrs: {
                    menu_item: footer_link,
                    "has-children": footer_link.children ? true : false,
                    selected: footer_link.object_id == _vm.current_id,
                  },
                })
              }),
              1
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "lower container" }, [
      _c("div", { staticClass: "inner" }, [
        _c(
          "div",
          { staticClass: "center" },
          [
            _vm.parsedGlobalSettings.general.privacy_policy
              ? _c("span", [_vm._v("|")])
              : _vm._e(),
            _vm._v(" "),
            _vm.parsedGlobalSettings.general.privacy_policy
              ? _c("menu-item", {
                  attrs: {
                    menu_item: _vm.parsedGlobalSettings.general.privacy_policy,
                    "has-children": _vm.parsedGlobalSettings.general
                      .privacy_policy.children
                      ? true
                      : false,
                    selected:
                      _vm.parsedGlobalSettings.general.privacy_policy
                        .object_id == _vm.current_id,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.parsedGlobalSettings.general.built_by
              ? _c("span", { staticClass: "sep" }, [_vm._v("|")])
              : _vm._e(),
            _vm._v(" "),
            _vm.parsedGlobalSettings.general.built_by
              ? _c("menu-item", {
                  attrs: {
                    menu_item: _vm.parsedGlobalSettings.general.built_by,
                    "has-children": _vm.parsedGlobalSettings.general.built_by
                      .children
                      ? true
                      : false,
                    selected:
                      _vm.parsedGlobalSettings.general.built_by.object_id ==
                      _vm.current_id,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.parsedGlobalSettings.footer.disclaimer
          ? _c("div", {
              staticClass: "disclaimer",
              domProps: {
                innerHTML: _vm._s(_vm.parsedGlobalSettings.footer.disclaimer),
              },
            })
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }